<template>
<div key="weather_page" class="page page-weather">
    <h2 class="page-header">Weather Forecast</h2>
    <Weather :key="'weather_for_'+woeid" detailed :woeid="woeid" />
</div>
</template>

<script>
// @ is an alias to /src
import Weather from '@/components/Weather.vue'

export default {
  name: 'weather',
  components: {
    Weather
  },
  computed: {
    woeid: function(){
        return String(this.$route.params.woeid);
    }
  }
}
</script>
